export const ANNUAL_POWER_STEPS = [
  { number: 1, label: 'Annual Power' },
  { number: 2, label: 'Register' },
  { number: 3, label: 'Checkout' },
];

export const DEFAULT_STEPS = [
  { number: 1, label: 'Register' },
  { number: 2, label: 'Checkout' },
];
